import { __assign, __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import React, { useRef, useState, useEffect } from 'react';
import { Box, Autocomplete, TextInputWithTokens } from '@primer/react';
import LTFormControl from '../LTFormControl/index.js';
import isEmpty from 'lodash/isEmpty';

var styledInput = {
  backgroundColor: "bg.muted",
  borderColor: "border.default",
  paddingLeft: "10px",
  input: {
    "&::placeholder": {
      color: "fg.muted"
    }
  },
  "& > div > span": {
    borderRadius: "20px",
    backgroundColor: "blueAccent.bg",
    borderColor: "blueAccent.border",
    color: "blueAccent.fg",
    fontSize: "12px",
    height: "20px",
    marginLeft: "4px !important",
    svg: {
      display: "none",
      height: "16px",
      width: "16px"
    }
  },
  "& > div > span:hover": {
    backgroundColor: "blueAccent.hoverBg",
    borderColor: "blueAccent.border",
    borderRadius: "20px",
    color: "blueAccent.muted",
    fontSize: "12px",
    marginLeft: "4px !important",
    svg: {
      height: "16px",
      width: "16px"
    }
  },
  "& >div>span>span:nth-child(3)": {
    height: "20px",
    margin: "0px 6px",
    width: "20px"
  }
};
var styledOverlay = {
  '&[aria-selected="false"]': {
    "> div > svg > rect": {
      fill: "switchTrack.activeBg",
      stroke: "border.default"
    }
  },
  "& > div": {
    "&:hover": {
      backgroundColor: "transparent !important"
    }
  },
  "& > div > div": {
    "&:hover": {
      backgroundColor: "transparent !important"
    }
  },
  "& > div > div>span": {
    "&:hover": {
      backgroundColor: "transparent !important"
    }
  },
  "& > div > svg": {
    "&:hover": {
      backgroundColor: "transparent !important"
    }
  },
  "& > div > svg > rect": {
    fill: "accent.fg",
    stroke: "accent.fg"
  },
  " &> div > svg.octicon-plus": {
    fill: "accent.fg"
  }
};
var LTAutoComplete = function LTAutoComplete(_a) {
  var _b;
  var _c = _a.ariaLabel,
    ariaLabel = _c === void 0 ? undefined : _c,
    _d = _a.ariaDescribedBy,
    ariaDescribedBy = _d === void 0 ? undefined : _d,
    _e = _a.ariaLabelledBy,
    ariaLabelledBy = _e === void 0 ? undefined : _e,
    _f = _a.enableNewTagCreation,
    enableNewTagCreation = _f === void 0 ? false : _f,
    _g = _a.defaultOptions,
    defaultOptions = _g === void 0 ? [] : _g,
    _h = _a.id,
    id = _h === void 0 ? "" : _h,
    inputExtraStyles = _a.inputExtraStyles,
    _j = _a.label,
    label = _j === void 0 ? "" : _j,
    _k = _a.labelStyles,
    labelStyles = _k === void 0 ? {} : _k,
    _l = _a.logErrorHandler,
    logErrorHandler = _l === void 0 ? function () {} : _l,
    _m = _a.maxItems,
    maxItems = _m === void 0 ? 5 : _m,
    _o = _a.maximumCharactersInTag,
    maximumCharactersInTag = _o === void 0 ? 50 : _o,
    _p = _a.onChange,
    onChange = _p === void 0 ? function () {} : _p,
    overlayStyles = _a.overlayStyles,
    _q = _a.options,
    options = _q === void 0 ? [] : _q;
    _a.overlayTop;
    var _s = _a.overlayLeft,
    overlayLeft = _s === void 0 ? 0 : _s,
    _t = _a.placeholder,
    placeholder = _t === void 0 ? "" : _t,
    _u = _a.stickyPlaceholder,
    stickyPlaceholder = _u === void 0 ? false : _u,
    width = _a.width;
  var areTokensAdded = useRef(false);
  var _v = useState(defaultOptions),
    tokens = _v[0],
    setTokens = _v[1];
  var selectedTokenIds = tokens === null || tokens === void 0 ? void 0 : tokens.map(function (token) {
    return token.id;
  });
  var _w = useState(selectedTokenIds),
    selectedItemIds = _w[0],
    setSelectedItemIds = _w[1];
  var _x = useState(options),
    localItemsState = _x[0],
    setLocalItemsState = _x[1];
  var _y = useState(""),
    filterVal = _y[0],
    setFilterVal = _y[1];
  var ariaLabelledByToUse = ariaLabelledBy || "autocompleteLabel-addItem__".concat(id);
  useEffect(function () {
    if (localItemsState.length === 0) setLocalItemsState(options);
  }, [options]);
  useEffect(function () {
    if (defaultOptions.length > 0 && !areTokensAdded.current) {
      setTokens(defaultOptions);
      var ids = defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.map(function (token) {
        return token.id;
      });
      setSelectedItemIds(ids);
      areTokensAdded.current = true;
    }
  }, [defaultOptions]);
  useEffect(function () {
    var selectedTags = tokens.filter(function (tag) {
      return selectedTokenIds.includes(tag.id);
    });
    onChange(selectedTags);
  }, [tokens]);
  var handleChangeInput = function handleChangeInput(event) {
    setFilterVal(event.currentTarget.value);
  };
  var onItemSelect = function onItemSelect(item) {
    onSelectedChange(__spreadArray(__spreadArray([], selectedItemIds.map(function (id) {
      return localItemsState.find(function (selectedItem) {
        return selectedItem.id === id;
      });
    }), true), [item], false));
    if (!localItemsState.some(function (localItem) {
      return localItem.id === item.id;
    })) {
      setLocalItemsState(__spreadArray(__spreadArray([], localItemsState, true), [item], false));
    }
  };
  var onTokenRemove = function onTokenRemove(tokenId) {
    var updatedTokens = tokens.filter(function (token) {
      return token.id !== tokenId;
    });
    setTokens(updatedTokens);
    setSelectedItemIds(selectedItemIds.filter(function (id) {
      return id !== tokenId;
    }));
  };
  var addNewItem = function addNewItem(item) {
    if (filterVal.length > maximumCharactersInTag) {
      logErrorHandler("Max ".concat(filterVal.length, " characters are allowed"));
    } else {
      logErrorHandler(null);
      onItemSelect(__assign(__assign({}, item), {
        id: localItemsState.length + 1,
        selected: true,
        text: filterVal
      }));
      setFilterVal("");
    }
  };
  var onSelectedChange = function onSelectedChange(newlySelectedItems) {
    if (!Array.isArray(newlySelectedItems)) {
      return;
    }
    if (newlySelectedItems.length > maxItems) {
      logErrorHandler("only ".concat(maxItems, " are allowed to add"));
      return;
    }
    if (newlySelectedItems.length <= maxItems) {
      logErrorHandler(null);
    }
    setSelectedItemIds(newlySelectedItems.map(function (item) {
      return item.id;
    }));
    setTokens(newlySelectedItems.map(function (_a) {
      var id = _a.id,
        text = _a.text;
      return {
        id: id,
        text: text
      };
    }));
  };
  var ariaLabelledById = "autocompleteLabel-addItem__".concat(id);
  var placeholderText = stickyPlaceholder || isEmpty(selectedItemIds) ? placeholder : null;
  // Define the addNewItem object
  var createAndAddNewTag = filterVal && !localItemsState.map(function (localItem) {
    return localItem.text;
  }).includes(filterVal) ? {
    text: "Create New Tag :'".concat(filterVal, "'"),
    handleAddItem: function handleAddItem(item) {
      addNewItem(item);
      setFilterVal("");
    }
  } : undefined;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: "100%",
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement(LTFormControl, {
    id: "".concat(id, "__input"),
    label: label,
    labelStyle: labelStyles
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: "".concat(width, "px !important"),
      display: "flex",
      "> span": {
        flexGrow: "1"
      }
    }
  }, /*#__PURE__*/React.createElement(Autocomplete, null, /*#__PURE__*/React.createElement(Autocomplete.Input, {
    as: TextInputWithTokens,
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : undefined,
    "aria-describedby": ariaDescribedBy !== null && ariaDescribedBy !== void 0 ? ariaDescribedBy : undefined,
    "aria-expanded": true,
    id: "".concat(id, "__input"),
    onTokenRemove: onTokenRemove,
    onChange: handleChangeInput,
    placeholder: placeholderText,
    sx: __assign(__assign({}, styledInput), inputExtraStyles),
    tokens: tokens
  }), /*#__PURE__*/React.createElement(Autocomplete.Overlay, {
    sx: __assign((_b = {
      width: "".concat(width, "px"),
      height: "175px",
      overflow: "auto"
    }, _b["> span > div > div[aria-labelledby=\"".concat(ariaLabelledById, "\"] > div > div")] = __assign({}, styledOverlay), _b), overlayStyles),
    left: overlayLeft
  }, enableNewTagCreation && /*#__PURE__*/React.createElement(Autocomplete.Menu, {
    addNewItem: createAndAddNewTag,
    items: localItemsState,
    selectedItemIds: selectedItemIds,
    onSelectedChange: onSelectedChange,
    selectionVariant: "multiple",
    "aria-labelledby": ariaLabelledByToUse
  }), !enableNewTagCreation && /*#__PURE__*/React.createElement(Autocomplete.Menu, {
    items: localItemsState,
    selectedItemIds: selectedItemIds,
    onSelectedChange: onSelectedChange,
    selectionVariant: "multiple",
    "aria-labelledby": ariaLabelledByToUse
  }))))));
};

export { LTAutoComplete as default };
